import React, { useEffect, useState } from "react";
import { TextField } from "../components/TextField";
import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";
import { NotificationFilterBar } from "../components/NotificationFilterBar";
import { Button } from "@/shared/components/ui/button";
import { Users, UserCheck, AlertCircle, FileSpreadsheet } from "lucide-react";
import { getNotifications, resendNotification } from "../api/notifications";
import { NotificationsTable } from "../components/table/NotificationsTable";
import type { NotificationItem, NotificationsResponse } from "../types";
import { NotificationHeader } from "../components/header/NotificationHeader";
import { NotificationsFilters } from "../components/filters/NotificationsFilters";
import { toast } from "sonner";

export interface NotificationsFiltersState {
  status: string;
  page: number;
  pageSize: number;
  dateFrom: string;
  dateTo: string;
  search: string;
}

interface UploadError {
  line: number;
  code: string;
  message: string;
}

export const NotificationsPage = () => {
  const [notifications, setNotifications] = useState<NotificationItem[]>([]);
  const [data, setData] = useState<NotificationsResponse>();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [filters, setFilters] = useState<NotificationsFiltersState>({
    status: "",
    page: 1,
    pageSize: 20,
    dateFrom: "",
    dateTo: "",
    search: "",
  });

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await getNotifications(filters);
        setData(res);
        setNotifications(res.data);
      } catch (error) {
        const message =
          error instanceof Error
            ? error.message
            : "Не удалось добавить пользователя";
        toast.error(message);
        console.error(error);
      }
    };

    fetchOrders();
  }, [filters]);

  const handleResendNotification = async (id: number) => {
    try {
      const resend = await resendNotification(id);

      if (resend.errors) {
        toast.error(
          <div>
            {resend.errors.map((e: UploadError, i: number) => (
              <div key={i}>
                Строка {e.line}: {e.message}
              </div>
            ))}
          </div>
        );
        return;
      }
      toast.success("Рассылка выполнена");
    } catch (e) {
      const message = e instanceof Error ? e.message : "Ошибка";
      toast.error(message);
    }
  };
  return (
    <div className="max-w-[1400px] mx-auto">
      <NotificationHeader />
      <NotificationsFilters
        totalCount={data?.total ?? 0}
        filteredCount={data?.data.length ?? 0}
        setFilters={setFilters}
        filters={filters}
      />
      <NotificationsTable
        notifications={notifications}
        page={filters.page}
        pageSize={filters.pageSize}
        total={data?.total ?? 0}
        onPageChange={(page) => setFilters((prev) => ({ ...prev, page }))}
        handleResendNotification={handleResendNotification}
      />
    </div>
  );
};
